export const messages = {
  en: {
    couponDetail: {
      queryCondition: 'Query Conditions',
      enterCouponName: 'Please enter coupon name',
      selectPurchaseTime: 'Select purchase time',
      purchaseRecord: 'Purchase Records',
      detailId: 'Merchant Purchase ID',
      couponName: 'Coupon',
      faceValue: 'Face Value',
      purchasePrice: 'Purchase Price',
      paymentAmount: 'Payment Amount',
      purchaseQuantity: 'Purchase Quantity',
      validityPeriod: 'Validity Period',
      purchaseTime: 'Purchase Time'
    }
  },
  zh: {
    couponDetail: {
      queryCondition: '查询条件',
      enterCouponName: '请输入优惠券名称',
      selectPurchaseTime: '请选择购买时间',
      purchaseRecord: '购买记录',
      detailId: '商家购买记录ID',
      couponName: '优惠券',
      faceValue: '面值',
      purchasePrice: '购买价格',
      paymentAmount: '付款金额',
      purchaseQuantity: '购买数量',
      validityPeriod: '有效期',
      purchaseTime: '购买时间'
    }
  }
}